import { publicUrl } from '@chegg-wt/core/utils/url'
import LottieAnimation from '../../LottieAnimations'

const ImproveWritingAnimation: React.FC<{ height: number; width: number }> = ({
  height,
  width,
}) => {
  return (
    <LottieAnimation
      height={height}
      width={width}
      url={publicUrl(`/static/animations/improve-writing.json`)}
    />
  )
}

export default ImproveWritingAnimation
